import React from 'react';
export const UserIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon__nav">
      <svg className="svg-icon">
        <svg id="icon-mygfw" viewBox="0 0 1024 1024">
          <title>My GFW</title>
          <path
            className="path1"
            d="M402.657 629.443h191.303c82.197-73.64 83.018-193.658 83.018-194.951l-0.118-155.681c-13.809-62.696-97.652-118.955-178.551-118.955-80.941 0.038-164.78 56.377-178.594 119.036l-0.118 155.681c0 1.137 1.686 121.782 83.059 194.875v0zM132.613 891.366h731.358v-10.788l-266.161-159.721h-198.995l-266.203 159.801v10.713zM882.292 982.822h-767.925c-40.331 0-73.173-32.837-73.173-73.173v-80.743l270.479-162.387c-82.546-98.672-83.49-225.829-83.49-232.031l0.826-168.036c21.029-118.408 156.229-197.933 269.299-197.933h0.156c113.033 0 248.114 79.45 269.106 197.858l0.708 7.924 0.118 160.113c0 6.2-0.943 133.397-83.452 232.106l270.436 162.269v80.861c0 40.331-32.799 73.173-73.093 73.173v0z"
            fill="#555"
          ></path>
        </svg>
      </svg>
    </svg>
  );
};
